import noop from '@hc-frontend/shared-assets/src/js/utils/fp/noop'
import renderBoxesInit from './compareBoxes/renderBoxes'
import toggleClass from 'utils/DOM/toggleClass'
import textContent from 'utils/DOM/textContent'
import store from 'utils/store/withMiddleware'
import visitedPlans from './visitedPlans'
import forEach from 'utils/DOM/forEach'
import getById from 'utils/DOM/getById'
import { MAX_PLANS_TO_COMPARE } from 'core/constants/compareNumberPlans'
import { IS_ENROLL } from 'core/constants/environment'
import { preventOnCloseEvent } from 'core/services/onClose'

const compareNode = getById('compareBar')
const MIN_PLANS_TO_COMPARE = 2
let renderBoxes = noop

function renderCompare() {
  const state = store.getState()
  const totalPlans = state.plansToCompare.length
  const empty = totalPlans === 0
  const one = totalPlans === 1
  const two = totalPlans === 2
  const more = totalPlans > 1
  toggleClass(compareNode, 'd-none', empty)
  toggleClass(document.body, 'compare', !empty)
  toggleClass(document.body, 'one', one)
  toggleClass(document.body, 'more', more)
  toggleClass('#compare_rest-plans', 'd-none', !two)
  textContent('.compareBar_number', totalPlans)

  renderBoxes(state.plansToCompare)

  if (empty) {
    forEach('.plan__compare-input:checked', check => (check.checked = false))
  }
}

function handleRemoveAll() {
  const plansToCompare = []
  store.update({ plansToCompare }, true)
  renderCompare()
  visitedPlans.removeAllPlans()
}

function goToCompare(e) {
  const state = store.getState()
  preventOnCloseEvent()
  if (state.plansToCompare.length < MIN_PLANS_TO_COMPARE) {
    e.preventDefault()
    return false
  }

  e.target.href = `${e.target.href}${state.plansToCompare.join(',')}`
}

function preCheckPlans() {
  const state = store.getState()
  const plansFromSession = state.plansToCompare

  if (plansFromSession.length > 0) {
    plansFromSession.forEach(planId => {
      const node =
        document.getElementById(planId) || document.getElementById(`${planId}-tile`)
      const wrap =
        document.querySelector(`[data-id="${planId}"]`) ||
        document.querySelector(`[data-planid="${planId}"]`)

      if (node) {
        node.checked = true
        wrap.classList.add('plan--visited')
        renderCompare()
      }
    })
  }
}

function init(maxPlansToCompare = MAX_PLANS_TO_COMPARE) {
  const state = store.getState()
  const plansFromSession = visitedPlans.init(
    state.hcStorage.healthcareSession,
    maxPlansToCompare
  )
  store.update({ plansToCompare: plansFromSession, plansVisited: plansFromSession }, true)
  renderBoxes = renderBoxesInit(state, maxPlansToCompare)
  preCheckPlans()
}

function handleCompareClose() {
  const id = this.getAttribute('for')

  const state = store.getState()
  const plansToCompare = state.plansToCompare.filter(idPlan => idPlan !== id)

  if (plansToCompare.length !== state.plansToCompare.length) {
    store.update({ plansToCompare }, true)
    visitedPlans.removePlan(id)
    renderCompare()
    window.dataLayerPushEvent(`SELECT_PLAN_COMPARE_QUOTE-${id}`)
  }

  const [planId, period, recurrence] = id.split('-')
  const compareInput = getById(`${planId}-${period}${IS_ENROLL ? `-${recurrence}` : ''}`)
  if (compareInput) {
    compareInput.checked = false
  }
}

function updateExtended(planId, policies) {
  const state = store.getState()
  const plansToCompare = state.plansToCompare

  for (let index = 0; index < plansToCompare.length; index++) {
    const id = plansToCompare[index]

    if (id.startsWith(planId)) {
      const newPlanId = `${planId}${policies > 1 ? `-${policies}` : ''}`
      plansToCompare[index] = newPlanId
      visitedPlans.removePlan(planId)
      visitedPlans.addPlan(newPlanId)
      store.update({ plansToCompare }, true)
      break
    }
  }
  renderBoxes(plansToCompare)
}

export default {
  handleCompareClose,
  handleRemoveAll,
  updateExtended,
  renderCompare,
  goToCompare,
  init
}
